import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DocumentsService } from '../../customer/documents/documents.service';
import { TokenService } from '../../token/token.service';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'zest-file-upload-progress',
  templateUrl: './file-upload-progress.component.html',
  styleUrls: ['./file-upload-progress.component.scss']
})
export class FileUploadProgressComponent implements OnInit, OnDestroy {

  public document: any;
  public canRemoveFile: boolean;
  public fileType: string;
  public documentSrc: any;
  public passwordRequired: boolean;
  public passwordValidated: boolean;
  public docPassword: string;
  public errorMessage: string;
  public fetchingDoc: boolean;
  public downloadingDoc: boolean;

  @Input() file: any;
  @Input() removableFile: boolean;
  @Input() postUploadPreview: boolean;
  @Input() postUploadDownload: boolean;

  @Output() removeFileEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private documentService: DocumentsService, private tokenService: TokenService) { }

  ngOnInit() {
    this.document = this.file;
    this.canRemoveFile = this.removableFile;
  }
  removeFile() {
    this.removeFileEvent.emit();
  }
  downloadFile() {
    this.downloadingDoc = true;
    this.documentService.fetchCompleteDocument(this.document.documentId).subscribe(response => {
      const url = window.URL.createObjectURL(this.documentService.base64StringToArrayBuffer(response.fileContent, response.fileExtension));
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = response.fileName + '.' + response.fileExtension;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.downloadingDoc = false;
    },
      error => {
        this.downloadingDoc = false;
        this.tokenService.removeAllToasts();
        Materialize.toast('Unable to Download. Please try again later.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
      }
    );
  }
  previewPdf(content: any, passwordReceived?: string) {
    this.fetchingDoc = false;
    setTimeout(fn => {
      $('#pdfViewModal.modal').modal();
      $('#pdfViewModal').modal('open');
    }, 0);
    this.documentSrc = null;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.documentSrc = { url: URL.createObjectURL(this.documentService.base64StringToArrayBuffer(content, 'pdf')), password: passwordReceived };
    };
    reader.readAsArrayBuffer(this.documentService.base64StringToArrayBuffer(content, 'pdf'));
  }

  previewDoc() {
    this.fetchingDoc = true;
    this.documentSrc = null;
    this.passwordRequired = false;
    this.passwordValidated = false;
    this.fileType = null;
    if (!this.document.fileContent) {
      this.documentService.fetchCompleteDocument(this.document.documentId).subscribe(response => {
        this.fileType = response.fileExtension;
        this.document.fileContent = response.fileContent;
        this.document.fileExtension = response.fileExtension;
        if (this.fileType === 'pdf') {
          this.previewPdf(response.fileContent);
        } else {
          this.previewImage(response.fileContent);
        }
      },
        error => {
          this.fetchingDoc = false;
          this.tokenService.removeAllToasts();
          Materialize.toast('Preview unavailable. Please try again later.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
        }
      );
    } else {
      this.fileType = this.document.fileExtension;
      if (this.fileType === 'pdf') {
        this.previewPdf(this.document.fileContent);
      } else {
        this.previewImage(this.document.fileContent);
      }
    }
  }

  previewImage(content) {
    this.fetchingDoc = false;
    setTimeout(fn => {
      $('#imageViewModal.modal').modal();
      $('#imageViewModal').modal('open');
    }, 0);
    if (typeof (FileReader) !== 'undefined') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.documentSrc = 'data:image/jpeg;base64,' + content;
      };
      reader.readAsDataURL(this.documentService.base64StringToArrayBuffer(content, 'image/*'));
    }
  }

  closeModal(modalId) {
    setTimeout(fn => {
      $('#' + modalId).modal('close');
      this.documentSrc = null;
      this.fileType = null;
    }, 0);
  }

  validatePasswordInput() {
    if (!this.docPassword) {
      this.errorMessage = 'The document requires a password to be opened.';
    } else {
      this.errorMessage = '';
    }
  }

  fetchDocumentPassword() {
    this.passwordValidated = true;
    this.previewPdf(this.document.fileContent, this.docPassword);
  }

  onError(event) {
    if (event.name === 'PasswordException') {
      this.passwordRequired = true;
      this.passwordValidated = false;
      this.docPassword = '';
      this.errorMessage = 'The document requires a password to be opened.';
    }
  }
  pdfLoadingComplete() {
    this.passwordValidated = true;
  }

  ngOnDestroy() {
    this.tokenService.removeAllModals();
    $('.modal-overlay').remove();
  }

}
